import LocalizedStrings from 'react-localization';

let localStrings = new LocalizedStrings({
  fr: {
    brandName: "Nom de l'enseigne",
    brandId: "Identifiant de l'enseigne",
    authKey: "Clé d'authentification",
    contactEmail: "Email de contact",
    chatAiAskPlaceholder: "Posez votre question à l'assistant IA",
    chatAiErrorMessage: "Une erreur s'est produite lors de la récupération des données de l'IA. Veuillez réessayer plus tard.",
    foodLytikAiAssistant: "Assistant IA Foodlytik",
    askYourQuestion: "Posez votre question",
    topTenByTurnover: "Top 10 par chiffre d'affaire",
    topTenByQuantity: "Top 10 par quantité",
    nbOrders: "Nombre de commandes",
    noDashBoradYet: "Vous n'avez pas encore de tableau de bord, vous pouvez gerer vos tableaux de bord en cliquant sur le bouton ci-dessous.",
    noItemYet: "Vous n'avez pas encore d'elements cliquez sur le bouton ci-dessus. pour ajouter un élément.",
    noBoardFound: "Aucun tableau de bord trouvé",
    periodSelector: "Sélection de période",
    normal: "Normal",
    high: "Haut",
    contrast: "Contraste",
    blendIn: "fondu dans le décor",
    discreet: "discret",
    evident: "évident",

    navColor: "Couleur de la navigation",
    light: "Clair",
    dark: "Sombre",
    colorSheme: "Thème de couleur",
    green: "Vert",
    blue: "Bleu",
    indigo: "Indigo",
    purple: "Violet",
    primaryColors: "Couleurs primaires",
    importOnGoing: "Import en cours",
    lastUpdateDate: "Dernière date mise à jour: {0}",
    gridEdit: "Editer de le tableau",
    backToHome: "Retour à l'accueil",
    notFoundPageExplanation: "Vous avez peut-être essayé un chemin incorrect ou vous êtes arrivé ici par erreur. Dans tous les cas, essayez d'utiliser la navigation.",
    notFoundPage: "404: Page non trouvée",
    unknown: "Inconnu",
    totalDiscount: "Remises (€)",
    offeredCount: "Nombre de remises",
    totalDuration: "Durée totale (min)",
    averageDuration: "Durée moyenne (min)",
    averageSeatTicket: "Ticket moyen avec couvert",
    averageSeatTurnover: "Couvert Moyen (€)",
    nbSeats: "Nombre de couverts",
    averageTicket: "Ticket moyen (€)",
    timeSlot: "Créneaux horaires",
    summary: "Résumé",
    manageMyBoards: "Gérer mes tableaux de bord",
    myDashboards: "Mes tableaux de bord",
    optionName: "Nom de l'option",
    quantity: "Quantité",
    staffNameDisplay: "Employé: {0}",
    tableNameDisplay: "Table: {0}",
    orderItemDisplay: "Commande: {0}",
    productOptionsCount: "Nombre d'options",
    productSalesCount: "Nombre de ventes de produits",
    totalWithTax: "Total avec taxes",
    totalTaxes: "Total des taxes",
    payment_types: "Types de paiement",
    table_name: "Nom de la table",
    sequId: "identifiant séquence",
    fromDate: "Debut: {0}",
    staff_name: "Nom de l'employé",
    nb_seats: "Nombre de couverts",
    end_time: "Heure de fin",
    startTime: "Heure de début",
    onlyAvailableInSingleDayMode: "Disponible uniquement en mode journée",
    accounting: "Comptabilité",
    accountingDetail: "Comptabilité: debut: {0} fin: {1}",
    noDataInChart: "Pas de données dans le graphique",
    cannotDisplayChart: "Impossible d'afficher le graphique",
    heightInPixel: "Hauteur en pixel",
    title: "Titre",
    removeGraphFromDashBoard: "Supprimer le graphique du tableau de bord",
    addGraphToDashBoard: "Ajouter un graphique au tableau de bord",
    reorderGraphInDashBoardActivate: "Activer le réordonnancement des graphiques",
    noFilterApplied: "Aucun filtre appliqué",
    addToDashBoard: "Ajouter au tableau de bord",
    noChartInCategory: "Aucun graphique dans cette catégorie",
    chartCategories: "Catégories",
    addChart: "Ajouter un graphique",
    publish: "Publier",
    description: "Description",
    grouping: "Regroupement",
    noGroupBy: "Aucun groupe",
    groupByLocation: "Grouper par lieu",
    groupByEstablishment: "Grouper par établissement",
    groupByProduct: "Grouper par produit",
    groupByStaff: "Grouper par employé",
    groupByCategory: "Grouper par catégorie",


    groups: "Groupes",
    allowedEstablishmentFilter: "Utiliser le filtre d'établissement",
    allowedStaffFilter: "Utiliser le filtre de personnel",
    allowedCategoryFilter: "Utiliser le filtre de catégorie",
    allowedProductFilter: "Utiliser le filtre de produit",
    allowedLocationFilter: "Utiliser le filtre d'emplacement",
    product: "Produit",
    location: "Emplacement",
    errors: "Erreurs",
    logs: "logs",
    refresh: "Rafraîchir",
    viewChartImplementation: "Voir le graphique",
    chartMediaUrl: "URL du média",
    mediaUrl: "URL du média",
    chartImplementationRoute: "Graphiques",
    chartCategoriesRoute: "Categories de graphiques",

    dataGridImplementationsRoute: "Tableaux de données",

    dashboardRoute: "Gerer mes tableaux de bord",

    pendingConfirmationUser: "en attente de confirmation",
    confirmedUser: "confirmé",
    actions: "Actions",
    status: "Statut",
    chatAiwelcomeMessage: "Bonjour, je suis l'assistant virtuel de Foodlytik. Je peux vous aider à trouver des informations sur votre restaurant. Que puis-je faire pour vous ?",
    chatAiNewConversation: "Nouvelle conversation",
    chatAiThinking: "Réflexion en cours...",
    chatAiNoResponse: "Je n'ai pas pu générer une réponse. Veuillez réessayer.",
    chatAiStopListening: "Arrêter l'écoute",
    chatAiStartListening: "Dicter un message",
    chatAiListening: "Parlez maintenant...",
    chatAiStopResponse: "Arrêter la réponse",
    timezone: "Fuseau horaire",
    customChart: "Graphique personnalisé",
    rhPeople: "Personne dans le système RH",
    rhMapping: "Correspondance RH",
    active: "Actif",
    equalogLogin: "Login Equalog",
    equalogPassword: "Mot de passe Equalog",
    humanResoucesSystems: "Systèmes de ressources humaines",
    posSystems: "Systèmes de point de vente",
    appSettings: "Paramètres de l'application",
    iaChatMessage: "Message IA",
    compareLastDay: "Comparé à {0} dernier",
    vsPreviousPeriod: "Vs période précédente",
    vsPreviousDay: "Vs jour précédent",
    vsPreviousWeek: "Vs semaine précédente",
    vsPreviousMonth: "Vs même mois année précédente",
    vsSameWeekLastMonth: "Vs même semaine mois dernier",
    vsPrevMonth: "Vs mois précédent",
    vsSameMonthLastYear: "Vs même mois année précédente",
    vsPreviousYear: "Vs année précédente",
    afternoonVsMorning: "Après-midi vs matin",
    vsSameWeekDay: "Vs même jour sem. précédente",
    // Short versions for mobile
    vsYesterday: "vs hier",
    vsLastWeek: "vs sem. dern.",
    vsLastMonth: "vs même mois année dern.",
    vsPrevMonthShort: "vs mois dern.",
    vsPrevYear: "vs année dern.",
    vsSameWeekLastMonthShort: "vs même sem. mois dern.",
    dayNames: {
      sunday: "dimanche",
      monday: "lundi",
      tuesday: "mardi",
      wednesday: "mercredi",
      thursday: "jeudi",
      friday: "vendredi",
      saturday: "samedi"
    },
    totalTurnover: "Chiffre d'affaire total",
    totalOrders: "Total des commandes",
    totalStaffPresent: "Total du personnel présent",
    inviteUser: "Inviter un utilisateur",
    useChargeOnline: "Utiliser le debit en ligne",
    blockWhenInsufficientCredit: "Bloquer lorsque le crédit est insuffisant",
    minimalCreditToLock: "Crédit minimal pour bloquer",
    addAccount: "Ajouter un compte",
    brandUsers: "Utilisateurs de l'enseigne",
    credits: "Crédits",
    adminSection: "Section Admin",
    loginError: "Erreur de connexion: {0}",
    loginErrorBadCredentail: "Erreur de connexion: Email ou mot de passe incorrect",
    loginIssue: "Problème de connexion: {0}",
    emailAddress: "Adresse email",
    aiChat: "IA Chat",
    aiImages: "Images IA",
    aiGeneratedImages: "Images générées par l'IA",
    searchImages: "Rechercher des images...",
    noImagesFoundFor: "Aucune image trouvée pour",
    noImagesGenerated: "Aucune image générée pour le moment",
    selectBrandAndEstablishment: "Veuillez sélectionner une marque et un établissement",
    downloaded: "Téléchargée",
    download: "Télécharger",
    date: "Date",
    size: "Taille",
    source: "Source",
    weekNumber: "Semaine {0}",
    options: "Options",
    distribution: "Distribution",
    list: "Liste",
    countryCode: "Code pays",
    detail: "Détail",
    count: "Nombre de vente",
    sale: "Volume de vente",
    category: "Catégorie",
    noFiltersAcive: "Aucun filtre actif",
    productName: "Nom du produit",
    price: "Prix",
    totalSales: "Ventes totales",
    salesCount: "Nombre de ventes",
    totalWorked: "Temps de de travail",
    products: "Produits",
    datePicker: "Sélectionner une date",
    filterType: "Type de filtre",
    noData: "Pas de données",
    staffs: "Employés",
    byProductType: "Par type de produit",
    byLocation: "Par lieu",
    byPaymentType: "Par type de paiement",
    byStaff: "Par employé",
    byPaymentMissing: "Par écart de caisse",
    data: "Données",
    filterYesterday: "Hier",
    filterCurrentWeek: "Cette semaine",
    filterWeek: "Semaine",
    filterCurrentMonth: "Ce mois",
    filterMonth: "Mois",
    filterCurrentYear: "Année en cours",
    filterYear: "Année",
    filterSingleDay: "Journée",
    filterPersonalysePeriod: "Période",

    // turnover: "Chiffre d'affaire",

    pieStaffTurnoverTitle: "Chiffre d'affaire par employé",
    turnover: "Chiffre d'affaire",
    staff: "Employé",
    startDateFormat: "Date de debut: {0}",
    filters: "Filtres",
    mainDashboard: "Tableau de bord principal",
    synchroniseDone: "Synchronisation terminée",
    stop: "Arrêter",
    synchronise: "Synchroniser",
    synchronisation: "Synchronisation",
    cashPadApiUserEmail: "Email de l'utilisateur CashApi",
    cashPadToken : "Token CashPad",
    cashPadClientName : "Nom du client CashPad",
    cashPadBaseUrl: "URL de base CashPad",

    integration: "Intégration",
    brand: "Enseigne",
    address: "Adresse",
    logout: "Déconnexion",
    createRestaurant: "Créer un restaurant",
    establishment: "Etablissement",
    chartCategory: "Catégorie de graphique",
    backToList: "Retour à la liste",
    general: "Général",
    name: "Nom",
    addRestaurant: "Ajouter un restaurant",
    restaurantList: "Liste des restaurants",

    establishmentList: "Liste des établissements",
    addEstablishment: "Ajouter un établissement",
    createEstablishment: "Créer un établissement",


    chartImplementation: "Graphique",
    chartImplementations: "Graphiques",
    chartImplementationList: "Liste des graphiques",
    addChartImplementation: "Ajouter un graphique",
    createChartImplementation: "Créer un graphique",
    updateChartImplementation: "Mettre à jour le graphique",

    dataGridImplementation: "Tableau de données",
    dataGridImplementations: "Tableaux de données",
    dataGridImplementationList: "Liste des tableaux de données",
    addDataGridImplementation: "Ajouter un tableau de données",
    createDataGridImplementation: "Créer un tableau de données",
    updateDataGridImplementation: "Mettre à jour le tableau de données",

    chartDashBoardList: "Liste des tableaux de bord",
    addDashBoard: "Ajouter un tableau de bord",
    createDashBoard: "Créer un tableau de bord",
    updateDashBoard: "Mettre à jour le tableau de bord",


    chartCategoryList: "Liste des catégories de graphiques",
    addChartCategory: "Ajouter une catégorie de graphique",
    createChartCategory: "Créer une catégorie de graphique",
    updateChartCategory: "Mettre à jour la catégorie de graphique",


    account: "Compte",
    update: "Mettre à jour",
    create: "Créer",
    management: "Gestion",
    building: "Construction",
    overview: "Vue d'ensemble",
    noCreditMessageTwo: "You are running out of credits, please buy some credits to continue using Food report",

    error: "Erreur",
    add: "Ajouter",
    edit: "Modifier",
    delete: "Supprimer",
    cancel: "Annuler",
    save: "Sauvegarder",
    search: "Rechercher",
    confirm: "Confirmer",
    submit: "Soumettre",

    billing: "Facturation",

    passwordChanged: "Votre mot de passe a été changé, retournez à la page de connexion et connectez-vous avec votre nouveau mot de passe",
    linkSent: "Un email a été envoyé à {0} avec les informations pour réinitialiser votre mot de passe",
    validationEmailDone: "Votre email a été validé",
    orLoginEmail: "Ou connectez-vous avec une adresse email",
    signInNow: "Connectez-vous maintenant",
    resetPassword: "Réinitialiser le mot de passe",

    visitWebSite: "Visitez notre site web",
    dontHaveAccount: "Vous n'avez pas de compte ?",
    signIn: "Connexion",
    haveAnAccount: "Vous avez un compte ?",
    signUpNow: "Inscrivez-vous maintenant",
    password: "Mot de passe",
    passwordConfirmation: "Confirmation du mot de passe",
    newPassword: "Nouveau mot de passe",
    newPasswordConfirmation: "Confirmation du nouveau mot de passe",
    useEmailTocreateNewAccount: "Utilisez votre email pour créer un nouveau compte",
    createNewAccount: "Créer un nouveau compte",
    backToLogin: "Retour à la connexion",
    loginWithGoogle: "Se connecter avec Google",
    allowUserToAccess: "Permettre à l'utilisateur d'accéder à mon compte",
    email: "Email",
    roles: "Rôles",
    pendingUser: "Utilisateur en attente",
    pendingUsers: "Utilisateurs en attente",
    usersInBrand: "Utilisateur dans la marque",

    createBrand: "Créer une enseigne",
    updateBrand: "Mettre à jour l'enseigne",

    mobileBottomBar: {
        dashboardNavForMobile: "Stats",
        turnOverLabel: "Chiffre",
        aiLabel: "IA",
        staffLabel: "Employés",
        homeLabel: "Accueil",
        productLabel: "Produits",
        dashboardLabel: "Tableau de bord",
        chatLabel: "Chat IA",
        periodLabel: "Période",
    },

    check: {
      wrongHoursValue: 'La valeur doit être comprise entre 0 et 24 heures',
      wrongMinutesValue: 'La valeur doit être comprise entre 0 et 60 minutes',
      wrongSecondsValue: 'La valeur doit être comprise entre 0 et 60 secondes',
      wrongUrlValue: 'Format d\'URL invalide',

      required: 'Requis',
      numberFormat: 'Le format doit être un nombre',
      fieldRequired: 'Le champ est obligatoire',
      urlFormat: 'L\'URL est dans un format incorrect',
      badEmailFormat: 'L\'email est dans un format incorrect',
      minuteFormat: 'Mauvais format pour la durée en minutes',
      msFormat: 'Mauvais format pour la durée en millisecondes',
      mustBeGreaterThan: 'Doit être supérieur à {0}',
      amountFormat: 'Le montant doit être un décimal avec deux chiffres maximum après la virgule',
      minAmount: 'Le montant minimal est de 50 crédits',
      passwordsMustMatch: 'Les mots de passe doivent correspondre',
      passwordNotValid: 'Le mot de passe doit contenir au minimum huit caractères, au moins une lettre, un chiffre et un caractère spécial parmi : @$!%*#?&.+',
    },
    confirmMessage: {
      // deleteItem: "Are you sure you want to delete selected board(s) ?",
      deleteWidget: "Êtes-vous sûr de vouloir supprimer le(s) widget(s) sélectionné(s) ?",
      deleteStripePayAccount: "Êtes-vous sûr de vouloir supprimer le(s) compte(s) sélectionné(s) ?",
      deleteBoard: "Êtes-vous sûr de vouloir supprimer le(s) tableau(x) sélectionné(s) ?",
      deleteProject: "Êtes-vous sûr de vouloir supprimer le(s) projet(s) sélectionné(s) ?",
      deleteMediaSequence: "Êtes-vous sûr de vouloir supprimer les séquences de média sélectionnées ?",
      deleteItem: "Êtes-vous sûr de vouloir supprimer le/les élément(s) sélectionné(s) ?",
      deleteSchedule: "Êtes-vous sûr de vouloir supprimer le(s) planning(s) sélectionné(s) ?",
      deleteLayout: "Êtes-vous sûr de vouloir supprimer la(les) mise(s) en page sélectionnée(s) ?",
      removeDevice: "Êtes-vous sûr de vouloir retirer l'(les) écran(s) sélectionné(s) ?",
      reboot: "Êtes-vous sûr de vouloir redémarrer cet appareil ?",
      update: "Êtes-vous sûr de vouloir mettre à jour et redémarrer cet écran ?",
      deleteMedia: "Êtes-vous sûr de vouloir supprimer ce média ?",
      deleteUser: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
      reloadSession: "Êtes-vous sûr de vouloir redemmarer la session de chat ?",
      deleteImage: "Êtes-vous sûr de vouloir supprimer cette image ?",
      confirmDelete: "Confirmer la suppression",

      deleteChartFromDashboard: "Êtes-vous sûr de vouloir supprimer le graphique du tableau de bord ?",
    },
    notif: {
      chartReorganizationDone: "Réorganisation du graphique effectuée",
      chartBoardItemRemoved: "Graphique supprimé du tableau de bord",
      rhAssociationDone: "Association RH effectuée",
      brandCreated: "Enseigne créée",
      brandUpdated: "Enseigne mise à jour",
      userPendingCreated: "Invitation envoyée",
      userPendingDeleted: "Utilisateur en attente supprimé",

      userDeleted: "Utilisateur supprimé",
      userCreated: "Utilisateur créé",
      userUpdated: "Utilisateur mis à jour",

      restaurantDeleted: "Restaurant supprimé",
      restaurantCreated: "Restaurant créé",
      restaurantUpdated: "Restaurant mis à jour",

      establishmentDeleted: "Etablissement supprimé",
      establishmentCreated: "Etablissement créé",
      establishmentUpdated: "Etablissement mis à jour",


      chartImplementationDeleted: "Graphique supprimé",
      chartImplementationCreated: "Graphique créé",
      chartImplementationUpdated: "Graphique mis à jour",

      dataGridImplementationCreated: "Tableau de données créé",
      dataGridImplementationUpdated: "Tableau de données mis à jour",
      dataGridImplementationDeleted: "Tableau de données supprimé",

      dashboardDeleted: "Tableau de bord supprimé",
      dashboardCreated: "Tableau de bord créé",
      dashboardUpdated: "Tableau de bord mis à jour",

      chartCategoryDeleted: "Catégorie de Graphique supprimé",
      chartCategoryCreated: "Catégorie de Graphique créé",
      charCategoryUpdated: "Catégorie de Graphique mise à jour",

      filterUpdated: "Filtre mis à jour",
      imageDownloadedSuccessfully: "Image téléchargée avec succès",
      imageDeleted: "Image supprimée avec succès",

      chartBoardItemAdded: "Graphique ajouté au tableau de bord",
    },
    content: {
      welcome: "Bienvenue sur foodlytik",
      welcomeHeader: "Obtenez des analyses approfondies sur la performance de votre restaurant",
      welcomeSubHeader: "Utilisez notre plateforme SaaS en ligne pour analyser les ventes, la performance des employés et les tendances clients grâce à des analyses alimentées par l'IA."    },
  },




});

export default localStrings;
